export default "__VITE_ASSET__WwAj4aCY__"